// Import necessary libraries
import React, { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import PopUp from "../components/PopUp";
import Spinner from "../components/Spinner";
import { Modal, Backdrop, Fade } from "@mui/material";
import GalleryComp from "../components/common/GalleryComp";
import GoogleMapComponent from "../components/GoogleMapComponent";
import GridContent from "../components/GridContent";

// Define your React component
const GridExample = () => {
  // State to hold grid data
  const [rowData, setRowData] = useState([]);
  const [isGalleryOpen, setGalleryOpen] = useState(false);
  const [selectedCellData, setSelectedCellData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  //Define column definitions
  const columnDefs = [
    {
      headerName: "Athlete",
      field: "athlete",
      cellStyle: { textAlign: "center" },
    },
    {
      headerName: "Age",
      field: "age",
      cellStyle: ageCellStyle,
    },
    {
      headerName: "Country",
      field: "country",
      cellStyle: { textAlign: "center" },
    },
    {
      headerName: "Year",
      field: "year",
      cellStyle: yearCellStyle,
    },
    // Add more columns as needed
  ];
 
  // Define default column definition
  const defaultColDef = {
    flex: 1,
    minWidth: 150,
    editable: true,
  };
 
  // Fetch data when component mounts
  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        const response = await fetch(
          "https://www.ag-grid.com/example-assets/olympic-winners.json"
        );
        const data = await response.json();
        setRowData(data);
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);
 
  // Cell style function for the 'Age' column
  function ageCellStyle(params) {
    const age = params.value;
    // Define your condition for cell color
    if (age < 20) {
      return {
        backgroundColor: "#5AC68D",
        color: "white",
        textAlign: "center",
      }; //green
    } else if (age >= 20 && age < 25) {
      return {
        backgroundColor: "#FFD54F",
        color: "black",
        textAlign: "center",
      }; //yellow
    } else {
      return {
        backgroundColor: "#FF8A80",
        color: "white",
        textAlign: "center",
      }; //red
    }
  }
 
  // Cell style function for the 'Year' column
  function yearCellStyle(params) {
    const year = params.value;
    // Define your condition for cell color
    if (year === 2008) {
      return {
        backgroundColor: "#5AC68D",
        color: "white",
        textAlign: "center",
      };
    } else if (year === 2004) {
      return {
        backgroundColor: "#FFD54F",
        color: "black",
        textAlign: "center",
      };
    } else if (year === 2000) {
      return {
        backgroundColor: "#FF8A80",
        color: "white",
        textAlign: "center",
      };
    } else {
      return { textAlign: "center" }; // Default style if no condition matches
    }
  }


  // Handle cell click
  const handleCellClick = (params) => {
    // Set the selected cell data
    setSelectedCellData(params.data);
    // Show the gallery
    setGalleryOpen(true);
  };

  // Close the gallery
  const handleCloseGallery = () => {
    setGalleryOpen(false);
  };

  // Return the Ag-Grid component and PopUp
  return (
    <>
      <h3>Module</h3>
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          {" "}
          <div
            className="ag-theme-alpine"
            style={{ height: "100vh", width: "100%" }}
          >
 
            <AgGridReact
              columnDefs={columnDefs}
              defaultColDef={defaultColDef}
              rowData={rowData}
              domLayout="autoHeight"
              pagination={true}
              paginationPageSize={13} // Adjust as needed
              suppressScrollOnNewData={true}
              animateRows={true}
              onCellClicked={handleCellClick} // Use onCellClicked event
            />
          </div>

          <Modal open={isGalleryOpen} onClose={handleCloseGallery}>
            <div className="gallery-popup">
              {/*<GalleryComp />*/}
              <GridContent/>
            </div>
          </Modal>
        </>
      )}
    </>
  );
};
 
export default GridExample;